export default __webpack_public_path__ + "static/media/toy-santa.3a0fa8d1.png";